import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MoonIcon, SunIcon } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';
export function ThemeToggle() {
  const {
    theme,
    toggleTheme
  } = useTheme();
  const isDark = theme === 'dark';
  return <button type="button" onClick={toggleTheme} role="switch" aria-checked={isDark} aria-label={`Switch to ${isDark ? 'light' : 'dark'} theme`} className="group relative flex h-8 w-[68px] items-center rounded-full border border-ink-700 bg-ink-800 px-1 transition-colors hover:border-ink-600" data-id="element-124" data-mp="3m3y22yrybr38">
      <motion.span layout transition={{
      type: 'spring',
      stiffness: 500,
      damping: 34
    }} className="flex h-6 w-6 items-center justify-center rounded-full bg-ink-600" style={{
      marginLeft: isDark ? 0 : 'auto'
    }} data-id="element-125" data-mp="2ydliurr9a7xc">
        <AnimatePresence mode="wait" initial={false} data-id="element-126" data-mp="dqs3i7i1tiv7">
          <motion.span key={theme} initial={{
          opacity: 0,
          rotate: -60,
          scale: 0.6
        }} animate={{
          opacity: 1,
          rotate: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          rotate: 60,
          scale: 0.6
        }} transition={{
          duration: 0.18
        }} className="flex" data-id="element-127" data-mp="im7gkx88faqk">
            {isDark ? <MoonIcon className="h-3.5 w-3.5 text-chalk" aria-hidden="true" data-id="element-128" data-mp="17c21alhivtda" /> : <SunIcon className="h-3.5 w-3.5 text-campaign" aria-hidden="true" data-id="element-129" data-mp="12d8pqylsqcfr" />}
          </motion.span>
        </AnimatePresence>
      </motion.span>
      <span className="pointer-events-none absolute inset-y-0 flex items-center font-mono text-[9px] uppercase tracking-[0.14em] text-faint" style={{
      [isDark ? 'right' : 'left']: 12
    } as React.CSSProperties} data-id="element-130" data-mp="skjdi1if8ujd">
        {isDark ? 'Dark' : 'Light'}
      </span>
    </button>;
}